import { TSchema, Type as t } from '@sinclair/typebox';

export const BaseSuccessResponseSchema = <T extends TSchema>(payload: T) =>
  t.Object({
    success: t.Literal(true),
    data: payload,
  });

export const BaseResponseSchema = <T extends TSchema>(payload: T) =>
  t.Union(
    [
      BaseSuccessResponseSchema(payload),
      t.Object({
        success: t.Literal(false),
        message: t.String(),
      }),
    ],
    { discriminator: 'success' },
  );

export const PaginatedResponseSchema = <T extends TSchema>(payload: T) =>
  t.Object({
    total: t.Number(),
    nextCursor: t.Optional(t.String()),
    list: t.Array(payload),
  });

export interface PaginatedResponse<T> {
  total: number;
  nextCursor?: string;
  list: T[];
}

export const PaginatedRequestParamsSchema = t.Object({
  limit: t.Number({ error: 'limit is required' }),
  cursor: t.Optional(t.String()),
});

export const Nullable = <T extends TSchema>(schema: T) =>
  t.Union([schema, t.Null()], {
    discriminator: 'type',
  });
